import Button from 'components/commons/buttons/button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { flyTo, mapLocationState, updateLocation } from 'redux/slices/mapSlice';
import { updatePermissionGeolocation } from 'redux/slices/permissionSlice';
import { RootState } from 'redux/store';
import { ReactComponent as IcUbi } from 'resources/icons/Ic_Ubi.svg';
import { IGeolocationCoordinates, IMapButtons } from 'types/interfaces';
import { getRequestLocation } from 'utils/utils';
//import MapLayersModal from './MapLayersModal';
import ZoomControl from './ZoomControl';
import { useEffect, useState } from 'react';

export default function MapControlButtons(props: IMapButtons) {
  const dispatch = useDispatch();
  const selectorLocation = useSelector(mapLocationState);
  const selectorPermission = useSelector((state: RootState) => state.permission);
  const [geoLocationPosition, setGeoLocationPosition] = useState<any>(undefined); // Estado para manejar la carga

  useEffect(() => {
    getRequestLocation()
      .then((geolocationPosition: any) => {
        setGeoLocationPosition(geolocationPosition);
      })
      .catch(() => dispatch(updatePermissionGeolocation(false)));
  }, []);
  function focus(mapFly: (location: IGeolocationCoordinates) => void) {
    if (selectorPermission.PermissionGeolocation === true && selectorLocation !== null) {
      selectorLocation && mapFly(selectorLocation);
    } else {
      if (geoLocationPosition !== undefined) {
        dispatch(updatePermissionGeolocation(true));
        dispatch(
          updateLocation({
            accuracy: geoLocationPosition.coords.accuracy,
            altitude: geoLocationPosition.coords.altitude,
            altitudeAccuracy: geoLocationPosition.coords.altitudeAccuracy,
            heading: geoLocationPosition.coords.heading,
            latitude: geoLocationPosition.coords.latitude,
            longitude: geoLocationPosition.coords.longitude,
            speed: geoLocationPosition.coords.speed,
            position: {
              lat: geoLocationPosition.coords.latitude,
              lng: geoLocationPosition.coords.longitude,
            },
          }),
        );
        mapFly(geoLocationPosition.coords);
      }
    }
  }

  return (
    <>
      <div className='map-control-buttons'>
        <Button
          className={`focus ${!selectorPermission.PermissionGeolocation ? 'neutro' : ''}`}
          ariaLabel='Mi ubicación'
          icon={IcUbi}
          onClick={(e) => {
            focus((geolocationCoordinates: IGeolocationCoordinates) => {
              dispatch(
                flyTo({
                  coords: {
                    lat: geolocationCoordinates.latitude,
                    lng: geolocationCoordinates.longitude,
                  },
                  zoom: null,
                }),
              );
            });
            e?.preventDefault();
          }}
        />
        <ZoomControl />
      </div>
    </>
  );
}
